import React from "react";
import { useParams, useNavigate } from "react-router-dom";
// import MockMeeting from "./MockMeeting";
import "./MeetingPage.scss";
import RealMeeting from "./RealMeeting";

const MeetingPage = () => {
  const { meetingId } = useParams();
  const navigate = useNavigate();

  const handleLeave = () => {
    navigate(-1);
  };

  return (
    <div className="mursal-meeting-page">
      <RealMeeting meetingId={meetingId} onLeave={handleLeave} />
      {/* <MockMeeting meetingId={meetingId} onLeave={handleLeave} /> */}
    </div>
  );
};

export default MeetingPage;
